<template>
  <!-- 新建派车 -->
  <div class="contentBox">
    <el-collapse v-model="activeNames">
      <!-- 发车信息 -->
      <el-collapse-item title="发车信息" name="1">
        <div class="infoDiv">
          <div class="formbox">
            <!-- :rules="rulesBaseInform" -->
            <el-form
              :model="departForm"
              ref="departFormRef"
              label-width="100px"
              class="glo_formBox"
            >
              <el-form-item label="发车批次" prop="dispatchNumber" required>
                <el-input
                  v-model="departForm.dispatchNumber"
                  placeholder="不填则保存后自动生成"
                  clearable
                  :disabled="!editable || feeCheckIn"
                ></el-input>
              </el-form-item>
              <el-form-item label="派车类型" prop="dispatchType" required>
                <el-select
                  filterable
                  clearable
                  v-model="departForm.dispatchType"
                  placeholder="请选择"
                  :disabled="!editable || feeCheckIn"
                >
                  <el-option
                    v-for="item in dispatchTypes"
                    :key="item.state"
                    :label="item.stateShow"
                    :value="item.state"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="出车时间" prop="planDepartureTime" required>
                <el-date-picker
                  v-model="departForm.planDepartureTime"
                  value-format="yyyy-MM-dd  HH:mm:ss"
                  type="datetime"
                  placeholder="请选择"
                  :disabled="!editable || feeCheckIn"
                ></el-date-picker>
              </el-form-item>
              <el-form-item label="始发网点:" prop="startDeptId" required>
                <el-select
                  v-model="departForm.startDeptId"
                  placeholder="请选择"
                  clearable
                  :disabled="!editable || feeCheckIn"
                  filterable
                >
                  <el-option
                    v-for="item in businessDepts"
                    :key="item.deptId"
                    :label="item.deptName"
                    :value="item.deptId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="queryItems" label="终端网点:">
                <el-select
                  filterable
                  clearable
                  v-model="departForm.endDeptId"
                  placeholder="请输入"
                  :disabled="!editable || feeCheckIn"
                >
                  <el-option
                    v-for="item in businessDepts"
                    :key="item.deptId"
                    :label="item.deptName"
                    :value="item.deptId"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="车辆类型"
                prop="carCategoryConfDictId"
                required
              >
                <el-select
                  filterable
                  clearable
                  v-model="departForm.carCategoryConfDictId"
                  placeholder="请选择"
                  @change="changecarCategoryConfDictId"
                  :disabled="!editable || feeCheckIn"
                >
                  <el-option
                    v-for="item in car_categoryList"
                    :key="item.id"
                    :label="item.val"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item required label="车牌号" prop="carNumber">
                <el-select
                  filterable
                  clearable
                  allow-create
                  remote
                  v-model="departForm.carNumber"
                  placeholder="请选择或输入"
                  :disabled="!editable || feeCheckIn"
                >
                  <el-option
                    v-for="(item, index) in carNumberList"
                    :key="index"
                    :label="item.carNumber"
                    :value="item.carNumber"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="driverOneName" label="司机姓名" required>
                <el-input
                  v-model="departForm.driverOneName"
                  placeholder="请输入"
                  clearable
                  :disabled="!editable || feeCheckIn"
                ></el-input>
              </el-form-item>
              <el-form-item prop="driverOnePhone" label="司机电话">
                <el-input
                  v-model="departForm.driverOnePhone"
                  placeholder="请输入"
                  clearable
                  :disabled="!editable || feeCheckIn"
                ></el-input>
              </el-form-item>
              <el-form-item prop="driverOneIdcard" label="身份证号">
                <el-input
                  v-model="departForm.driverOneIdcard"
                  placeholder="请输入"
                  clearable
                  :disabled="!editable || feeCheckIn"
                ></el-input>
              </el-form-item>
              <el-form-item label="合同编号" prop="dispatchContractNumber">
                <el-input
                  v-model="departForm.dispatchContractNumber"
                  placeholder="请输入"
                  clearable
                  :disabled="!editable || feeCheckIn"
                />
              </el-form-item>
              <el-form-item label="外发员" prop="outgoingPersonnelId">
                <el-select
                  filterable
                  clearable
                  v-model="departForm.outgoingPersonnelId"
                  placeholder="请选择"
                  :disabled="!editable || feeCheckIn"
                >
                  <el-option
                    v-for="emp in emps"
                    :key="emp.employeeId"
                    :label="emp.jobNumber"
                    :value="emp.employeeId"
                  >
                    <span style="float: left">{{ emp.jobNumber }}</span>
                    <span
                      style="float: right; color: #8492a6; font-size: 13px"
                      >{{ emp.employeeName }}</span
                    >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                class="textArea"
                style="width: 100%; height: auto"
                label="备注"
                prop="remarks"
                :disabled="!editable || feeCheckIn"
              >
                <el-input
                  placeholder="请输入"
                  clearable
                  rows="3"
                  v-model="departForm.remarks"
                  type="textarea"
                  :disabled="!editable || feeCheckIn"
                ></el-input>
              </el-form-item>
              <el-form-item prop="totalCount" label="总件数:">
                <el-input
                  v-model="departForm.totalCount"
                  placeholder="根据单据自动计算"
                  disabled
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item prop="totalWeight" label="总重量">
                <el-input
                  v-model="departForm.totalWeight"
                  placeholder="根据单据自动计算"
                  disabled
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item prop="totalVolume" label="总体积">
                <el-input
                  v-model="departForm.totalVolume"
                  placeholder="根据单据自动计算"
                  disabled
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item prop="totalVote" label="总票数">
                <el-input
                  v-model="departForm.totalVote"
                  placeholder="根据单据自动计算"
                  disabled
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item label="应付合计" prop="totalAmount">
                <el-input
                  v-model="departForm.totalAmount"
                  placeholder="根据下方数据自动算出"
                  disabled
                  type="number"
                ></el-input>
              </el-form-item>
              <el-form-item
                class="textArea"
                style="width: 100%"
                label="起止线路"
                prop="routes"
                :disabled="!editable || feeCheckIn"
              >
                <el-input
                  placeholder="点击途经网点选择途径网点，设置顺序，显示自动把始发网点、和终端网点作为起止点"
                  clearable
                  rows="2"
                  v-model="departForm.routes"
                  type="textarea"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="upload_pic" style="margin-bottom: 10px">
              <div
                style="
                  margin-bottom: 10px;
                  font-size: 13px;
                  color: #303133;
                  line-height: 1.769230769230769;
                "
              >
                上传图片: (支持上传jpg/png文件)
              </div>
              <my-image-upload
                @input="changeFileList"
                :fileNameLists="fileNameLists"
                :limit="9"
              ></my-image-upload>
            </div>
          </div>
        </div>
      </el-collapse-item>
      <!-- 运单/订单装载明细 -->
      <el-collapse-item name="2" class="details_item" title="途径网点">
        <trace
          :dispatchId="dispatchId"
          ref="waybill"
          :op="op"
          :isSee="isSee"
        ></trace>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import paging from "@/components/pagings.vue"; //分页组件
import Trace from "./Trace.vue";
import MyImageUpload from "@/components/MyImageUpload.vue";
export default {
  components: {
    paging,
    Trace,
    MyImageUpload,
  },
  props: {
    dispatchId: {},
    isSee: {},
    type: {
      type: String,
      require: false,
      default: "edit",
    },
    op: {
      type: String,
      require: false,
      default: "edit",
    },
  },
  data() {
    return {
      dispatchStatus: "未派车", // 派车状态
      activeNames: ["1", "2", "3"],
      departForm: {
        dispatchNumber: "",
        dispatchType: "",
        planDepartureTime: "",
        startDeptId: "",
        endDeptId: "",
        carCategoryConfDictId: "",
        carNumber: "",
        driverOneId: "",
        driverOneName: "",
        driverOnePhone: "",
        driverOneIdcard: "",
        dispatchContractNumber: "",
        outgoingPersonnelId: "",
        outgoingPersonnelName: "",
        remarks: "",
        totalCount: "",
        totalWeight: "",
        totalVolume: "",
        totalVote: "",
        totalAmount: "",
        route: "",
      },
      dispatchTypes: [],
      businessDepts: [], // 网点
      car_categoryList: [], //车辆分类
      carNumberList: [], // 车牌号
      fileNameLists: [], // 图片列表
      emps: [],
      /**------运单/订单明细表格 */
      isWaybill: true, // 运单/订单明细
      loadingDetails: [], // 运单/订单明细表格data
      pageStart: 1, //  页码
      pageCount: 0, //  总条数
      pageTotal: this.$COMMON.pageTotals, //  一页几条
      tableHeigth: "auto", //  表格高度
      selectTableData: [], //  表格选中的数据
      /**--------- */
      /**-------车次费用表格 */
      trainCostData: [],
      /**--------------- */
      previewSrcList: [],
      showViewer: false,
      carTiming: [],
    };
  },
  computed: {
    editable() {
      return false;
    },
    disabledSee() {
      return !this.editable;
    },
    feeCheckIn() {
      return this.op === "feeCheckIn";
    },
    baseEdit() {
      return this.op === "baseEdit";
    },
    intoStoreage() {
      return this.op === "intoStoreage";
    },
  },
  mounted() {
    this.getDispatchTypes();
    this.getBusinessDepts();
    this.getConfDictValDownList("car_category", "car_categoryList");
    // 员工
    this.getEmps();
    this.getDetail();
  },
  watch: {
    dispatchId: {
      handler(val) {
        if (!val) {
          return;
        }
        this.getDetail();
      },
    },
  },
  methods: {
    async getDetail() {
      if (this.dispatchId) {
        const detail = await this.$API.getDispatchUpdateDetail({
          dispatchId: this.dispatchId,
        });
        const result = detail.data.result;
        if (result.carCategoryConfDictId) {
          result.carCategoryConfDictId = parseInt(result.carCategoryConfDictId);
        }
        this.departForm = result;
        this.fileNameLists = result.files;
        this.carTiming = result.fianceOutInfos;
        this.dispatchStatus = result.dispatchStatusShow;
      }
    },
    async getEmps() {
      const res = await this.$API.runList({
        number: "down_list_employee",
      });
      this.emps = res;
    },
    // 根据字典类型获取字典值下拉列表 包装 车型 外发提货 外发送货方式
    async getConfDictValDownList(dictType, field) {
      const res = await this.$API.wtl_getConfDictValDownListV5(dictType);
      let arrs = res || [];
      // 其他情况
      this[field] = arrs;
    },
    // 获取营业网点
    async getBusinessDepts() {
      const data = await this.$API.runListReport({
        number: "business_dept_down_list",
      });
      this.businessDepts = data;
    },
    // 获取派车类型
    async getDispatchTypes() {
      const data = await this.$API.runListReport({
        number: "down_list_dispatch_type_v5",
      });
      this.dispatchTypes = data;
    },
    // 保存
    async submit(saveType) {
      const waybills = this.$refs.waybill ? this.$refs.waybill.getRows() : [];
      const commands = this.$refs.command ? this.$refs.command.getRows() : [];
      const carTimeings = this.$refs.carTiming.getRows();
      if (this.dispatchId) {
        if (this.feeCheckIn) {
          const res = await this.$API.saveDispatchFinance({
            dispatchId: this.dispatchId,
            fianceOutInfos: carTimeings,
            saveType,
          });
        } else {
          if (saveType == "SAVE") {
            const res = await this.$API.updateDispatch({
              ...this.departForm,
              dispatchId: this.dispatchId,
              billInfos: waybills,
              commandBillInfos: commands,
              fianceOutInfos: carTimeings,
              files: this.fileNameLists,
              saveType,
            });
            this.$message.success("保存成功");
          } else {
            const res = await this.$API.dispatchSure({
              dispatchIds: [this.dispatchId],
            });
            this.$message.success("调度成功");
          }
        }
      } else {
        console.log(this.departForm.dispatchType);
        const res = await this.$API.addDispatch({
          ...this.departForm,
          billInfos: waybills,
          commandBillInfos: commands,
          fianceOutInfos: carTimeings,
          files: this.fileNameLists,
          saveType,
        });
        this.$message.success(saveType == "SAVE" ? "保存成功" : "调度成功");
      }
      this.$emit("reset");
    },
    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },

    // 获取车辆下拉列表(拿车牌号码)
    async changecarCategoryConfDictId(e) {
      if (e) {
        const res = await this.$API.runList({
          number: "down_list_car",
          carCategoryConfDictId: e, //车辆分类id
        });
        this.carNumberList = res;
      }
    },
  },
};
</script>

<style scoped lang="less">
.contentBox {
  padding-bottom: 50px;
  overflow: auto;
  height: 100%;
  .dispatch_head {
    height: 50px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #ccc;
    .topBtns {
      background-color: #fff;
      margin-top: -10px;
      // height: 50px;
    }
    .waybill_Type {
      // margin-bottom: 10px;
      width: fit-content;
      height: max-content;
      color: #ff0000;
      font-weight: bold;
      border: 2px dashed transparent;
      border-radius: 5px;
      padding: 2px 12px;
      background: linear-gradient(#fff, #fff) padding-box,
        repeating-linear-gradient(
          -75deg,
          #ff0000 0,
          #ff0000 0.9em,
          #fff 0,
          #fff 1.2em
        );
    }
  }

  .infoDiv {
    // border-width: 1px 1px 0 1px;
    // border-style: solid;
    // border-color: #f59a23;
    display: flex;
    .formbox {
      // padding: 0 30px;
      padding: 0 10px;
      // width: calc(100% - 70px);
      width: 100%;
      .glo_formBox {
        // justify-content: space-between;
        .el-form-item {
          margin-right: 1.8%;
        }
        .double_item {
          /deep/.el-form-item__content {
            display: flex;
            .el-select {
              input {
                padding-left: 5px;
              }
            }
            .second_ipt {
              input {
                padding-left: 5px;
                padding-right: 10px;
              }
            }
            .unit {
              margin-right: 5px;
            }
          }
        }
        .Divider {
          width: 100%;
          height: 1px;
          margin-bottom: 10px;
          border-top: 1px dashed transparent;
          background: linear-gradient(#fff, #fff) padding-box,
            repeating-linear-gradient(
              -75deg,
              #797979 0,
              #797979 0.9em,
              #fff 0,
              #fff 1.2em
            );
        }
      }
      .head_formBox {
        justify-content: flex-start;
        margin: 15px 0 5px 0;
        .el-form-item {
          margin-bottom: 10px;
          // width: 18%;
          width: calc(24% - 2px);
          min-width: unset;
        }
      }
      .jsInput {
        .jsBtns {
          height: 30px;
          line-height: 30px;
          margin: 0;
          padding: 0 10px;
          border: none;
        }
      }
    }

    .goodsItmes {
      margin: 10px 0;
      // margin-top: 30px;
      // border-bottom: 4px solid #ccc;
      // padding-bottom: 20px;
    }

    .formBtns {
      height: 30px;
      margin: 0;
      padding: 0 10px;
    }

    .miniInput {
      width: 80px;
      border-left: 1px solid #ccc;
      border-right: 1px solid #ccc;
      margin-right: 2px;

      text-align: center;

      /deep/ .el-input__inner {
        text-align: center !important;
        padding: 0 5px;
      }
    }
  }
  .el-collapse {
    .details_item {
      .el-collapse-item__header {
        .active_item {
          background: #ffffff;
          color: #ef7c0a;
        }
        .soltTitle {
          padding: 0 10px;
        }
      }
    }
  }
  .cost_dia {
    /deep/.el-dialog {
      .glo_dialogForm {
        .diaForm {
          .el-row {
            width: 100%;
            .multipleSelect {
              display: flex;
              /deep/ .el-select {
                flex: 1;
              }
            }
          }
        }
      }
    }
  }
}
</style>